var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home" }, [
    _c("p", [_vm._v("Welcome back," + _vm._s(_vm.username))]),
    _vm._v(" "),
    _c("div", { staticClass: "dashboard" }, [
      _c(
        "p",
        {
          staticStyle: {
            "margin-bottom": "20px",
            "font-family": "Satoshi-Bold"
          }
        },
        [_vm._v("Dashboard")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "total" }, [
          _c("div", [
            _vm._v("Total Sales "),
            _c("span", [
              _vm._v(_vm._s(_vm.dashboard["totalOrder"]) + " Orders")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "format",
                  rawName: "v-format",
                  value: "$#,##0.00",
                  expression: "'$#,##0.00'"
                }
              ]
            },
            [_vm._v(_vm._s(_vm.dashboard["totalSales"]))]
          ),
          _vm._v(" "),
          _c("small", [_vm._v("Order Total")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "total middle" }, [
          _c("div", [
            _vm._v("Customer count "),
            _c("span", [_vm._v(_vm._s(_vm.dashboard["customerCount"]))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "middle-content" }, [
            _c("span", { staticStyle: { width: "180px" } }, [
              _vm._v(_vm._s(_vm.dashboard["repeatCustomers"]))
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "format",
                    rawName: "v-format",
                    value: "0.##%",
                    expression: "'0.##%'"
                  }
                ],
                staticStyle: { width: "90px" }
              },
              [_vm._v(_vm._s(_vm.dashboard["repurchaseRate"]))]
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "total right",
            staticStyle: { "border-right": "unset" }
          },
          [
            _c("div", [
              _vm._v("Total SPU "),
              _c("span", [_vm._v(_vm._s(_vm.dashboard["totalSpu"]))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "middle-content" }, [
              _c("span", [_vm._v(_vm._s(_vm.dashboard["sales"]))]),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "format",
                      rawName: "v-format",
                      value: "0.##%",
                      expression: "'0.##%'"
                    }
                  ],
                  staticStyle: { width: "130px" }
                },
                [_vm._v(_vm._s(_vm.dashboard["inventoryTurnoverRate"]))]
              )
            ]),
            _vm._v(" "),
            _vm._m(1)
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "orders" }, [
      _c("div", { staticClass: "title" }, [
        _c("div", [_vm._v("Orders")]),
        _vm._v(" "),
        _c(
          "div",
          {
            on: {
              click: function($event) {
                return _vm.$router.push({ path: "Order" })
              }
            }
          },
          [_vm._v("View All")]
        )
      ]),
      _vm._v(" "),
      _vm.orderList && _vm.orderList.length > 0
        ? _c(
            "div",
            [
              _c(
                "el-table",
                {
                  ref: "orderTable",
                  staticStyle: { border: "none !important" },
                  attrs: { data: _vm.orderList, "empty-text": "No data found" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "Creat Time",
                      "min-width": "15%"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    scope.row.createTime === null ||
                                      scope.row.createTime === undefined
                                      ? "--"
                                      : scope.row.createTime
                                  ) +
                                  "\n          "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3655596072
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "orderId", label: "ID", "min-width": "15%" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    scope.row.orderId === null ||
                                      scope.row.orderId === undefined
                                      ? "--"
                                      : scope.row.orderId
                                  ) +
                                  "\n          "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3201968346
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "storeName",
                      "min-width": "15%",
                      label: "Store Name"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    scope.row.storeName === null ||
                                      scope.row.storeName === undefined
                                      ? "--"
                                      : scope.row.storeName
                                  ) +
                                  "\n          "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2028151649
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "state",
                      "min-width": "10%",
                      label: "State"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("statusDis")(
                                      scope.row["orderStatus"]
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4251292284
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalPrice",
                      "min-width": "10%",
                      label: "Total"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    scope.row["totalPrice"]
                                      ? Number(
                                          scope.row["totalPrice"]
                                        ).toLocaleString("en-US", {
                                          style: "currency",
                                          currency: "USD"
                                        })
                                      : "--"
                                  ) +
                                  "\n          "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      527430368
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "", "min-width": "5%" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("i", {
                                staticClass: "el-icon-arrow-right arrow",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.detailOrder(scope["row"])
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3418087915
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _c("div", { staticStyle: { "text-align": "center" } }, [
            _vm._v("No orders available.")
          ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "orders" }, [
      _c("div", { staticClass: "title" }, [
        _c("div", [_vm._v("Customers")]),
        _vm._v(" "),
        _c(
          "div",
          {
            on: {
              click: function($event) {
                return _vm.$router.push({ path: "Customers" })
              }
            }
          },
          [_vm._v("View All")]
        )
      ]),
      _vm._v(" "),
      _vm.customerList && _vm.customerList.length > 0
        ? _c(
            "div",
            [
              _c(
                "el-table",
                {
                  ref: "orderTable",
                  staticStyle: { border: "none !important" },
                  attrs: {
                    data: _vm.customerList,
                    "empty-text": "No data found"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "lastLoginTime",
                      label: "Last login",
                      "min-width": "18%"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "-webkit-box",
                                    overflow: "hidden",
                                    "-webkit-line-clamp": "2",
                                    "-webkit-box-orient": "vertical",
                                    "white-space": "pre-line"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(scope.row.lastLoginTime) +
                                      "\n            "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      450657455
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "storeName",
                      label: "Store Name",
                      "min-width": "18%"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "-webkit-box",
                                    overflow: "hidden",
                                    "-webkit-line-clamp": "2",
                                    "-webkit-box-orient": "vertical",
                                    "white-space": "pre-line"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(scope.row.storeName) +
                                      "\n            "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3025486955
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalSales",
                      "min-width": "15%",
                      label: "Purchase amount"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "-webkit-box",
                                    "text-overflow": "ellipsis",
                                    overflow: "hidden",
                                    "-webkit-line-clamp": "2",
                                    "-webkit-box-orient": "vertical",
                                    "white-space": "pre-line"
                                  }
                                },
                                [
                                  scope.row.totalSales
                                    ? [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              scope.row.totalSales
                                                ? Number(
                                                    scope.row.totalSales
                                                  ).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD"
                                                  })
                                                : "--"
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                N/A\n              "
                                        )
                                      ]
                                ],
                                2
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3739386329
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "country",
                      "min-width": "18%",
                      label: "Location"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "-webkit-box",
                                    "text-overflow": "ellipsis",
                                    overflow: "hidden",
                                    "-webkit-line-clamp": "2",
                                    "-webkit-box-orient": "vertical",
                                    "white-space": "pre-line"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        scope.row["state"] &&
                                          scope.row["countryCode"]
                                          ? scope.row["state"] +
                                              " " +
                                              scope.row["countryCode"]
                                          : "--"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3903132952
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "repurchase",
                      "min-width": "10%",
                      label: "Repurchase"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "-webkit-box",
                                    "text-overflow": "ellipsis",
                                    overflow: "hidden",
                                    "-webkit-line-clamp": "2",
                                    "-webkit-box-orient": "vertical",
                                    "white-space": "pre-line"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        scope.row.repurchase
                                          ? scope.row.repurchase
                                          : "N/A"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      273714713
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("i", {
                                staticClass: "el-icon-arrow-right arrow",
                                staticStyle: {
                                  cursor: "pointer",
                                  bottom: "15px"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.detailCustomer(scope["row"])
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2781388948
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _c("div", { staticStyle: { "text-align": "center" } }, [
            _vm._v("No customers available")
          ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "middle-content" }, [
      _c("small", [_vm._v("Reoccurring Customers")]),
      _vm._v(" "),
      _c("small", { staticStyle: { width: "90px" } }, [
        _vm._v("Repurchase rate")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "middle-content" }, [
      _c("small", [_vm._v("Sales")]),
      _vm._v(" "),
      _c("small", { staticStyle: { width: "130px" } }, [
        _vm._v("Inventory turnover rate")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-206d5f41", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206d5f41","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/brand-home.vue
// module id = qI74
// module chunks = 2